export default class Resources {
  static FuelTypes = {
    GAS: 'gas',
    ELECTRICITY: 'electricity',
  };
  static SelectedSites = {
    UPLOADBILL: 'uploadBill',
    ADDADDRESS: 'addAddress',
  };

  static ErrorCodes = {
    DuplicateEntryCode: 409
  };

  static OutstandingAction = {
    QUOTEGENERATION: 'QUOTE_GENERATION',
    LOASIGN: 'LOA_SIGN',
    CONTRACTSIGN: 'CONTRACT_SIGN',
    CONTRACTTOBEG: 'CONTRACT_TO_BE_GENERATED'
  };

  static LocalStorageKeys = {
    searchedBusinessList: 'searchedBusinessList',
    authorisedPersonList: 'authorisedPersonList'
  };

  static envKey = {
    brokers: 'brokers',
  };

  static SessionStorageKeys = {
    Info: 'info',
    FuelType: 'fuel_type',
    SelectedSite: 'selectedSite',
    MultiSiteSelected: 'multisiteSelected',
    CustomerId: 'customerId',
    oldCustomerID: 'oldCustomerId',
    NewCustomerID: 'newCustomerId',
    MappingCustomerID: 'mappingCustomerID',
    MappingContactId: 'mappingContactId',
    SelectedAddress: 'selectedAddress',
    MeterInfo: 'meterInfo',
    MeterDetails: 'meterDetails',
    UploadBillData: 'uploadBillData',
    AddressSelect: 'addressSelect', // Removed : value was undefined & never used
    RollOverObj: 'rollOverObj',
    SiteId: 'siteId',
    CSInfo: 'csInfo',
    ContractEndDate: 'contractEndDate', // Need to update it to meterDetails.contractEndDate
    AmountData: 'amountData',
    ContactId: 'contactId', // // Need to update it to contactDetails.contactId
    SpendId: 'spendId',
    MeterOperatorData: 'meterOperatorData', // Need to update it to meterDetails.meterOperatorData
    DadcContractData: 'dadcContractData', // Need to update it to meterDetails.dadcContractData
    SelectedSupplierName: 'selectedSupplierName', // Need to update it to meterDetails.selectedSupplierName
    FromUploadBill: 'fromUploadBill',
    FromBillPage: 'fromBillPage',
    Email: 'email',  // Need to update it to contactDetails.email
    Company: 'company',
    CompanyIndex: 'companyIndex',
    AuthorisedPerson: 'authorisedperson', // Need to update it to authorisedPerson to contactDetails
    Phone: 'phone', // Need to update it to contactDetails.phone
    SelectedCompanyAddress: 'selectedCompanyAddress', // Need to  update it to company.sameAsBillingAddress & company.sameAsSupplyAddress , company.searchedBusiness
    SupplierToSwitch: 'supplierToSwitch',
    Bank: 'bank',
    ContactDetails: 'contactDetails',
    ContactDetailsUpload: 'contactDetailsUpload',
    DashboardSummary: 'dashboardSummary',
    QuoteCurrentSupply: 'quoteCurrentSupply',
    QuoteSummary: 'quoteSummary',
    IsLoggedInUser: 'isLoggedInUser',
    PageNumber: 'pageNumber',
    // AddAnotherContract: 'addAnotherContract',
    // AddAnotherContractCustomer: 'addAnotherContractCustomer',
    ShowSiteData: 'showSiteData',
    LoggedInUserEmail: 'loggedInUserMail',
    Token: 'token',
    UserSummary: 'userSummary',
    PaymentID: 'paymentid',
    contactIDBill: 'contactIdbill',
    selectedAuthName: 'selectedAuthName',
    MULTIPLESITES: 'multipleSites',

    //TP
    SpendCardList: 'spendCardList',
    TempSelectedAddress: 'tempSelectedAddress',
    SelectedAnnualCard: 'selectedAnnualCard',
    TempAddress: 'tempAddress',
    ButtonStatus: 'buttonStatus',
    PostCode: 'postCode',
    RbsFlow: 'rbsFlow',
    QuotesRolloverChange: 'withOutVATRollover',
    withOutVAT: 'vatDefault',
    VAT5: 'vat5%',
    VAT20: 'vat20%',
    preLogin: 'preLogin',
    GoBackQuotes: 'gobackFromQuotes',
    StatusActive: 'statusActive',
    SummaryAPICall: 'summaryAPIcalling',
    IntervelSpend: 'intervelSpend',
    selectedCompanyType: 'companyType',
    MultiFlowBankOptional: 'multiFlowBankOptional',
    NormalFlowBankOptional: 'normalFlowBankOptional',
    ChangeOfTenancy: 'changeofTenancy',
    Username: 'username',
    ContractId: 'contractId',
    Quotes: 'quotes',
    GenerateQuoteClicked: 'generateQuoteClicked',
    ConnectedapiSupplierInfo: 'connectedapiSupplierInfo',
    ContractRegeneration: 'contractRegeneration',
    LoaRegeneration: 'loaRegeneration',
    selectedSupplierName: 'selectedSupplierName',
    DownloadQuotes: 'downloadQuotes',
    BillingAddress: 'billingAddress',
    PreviousContractSpendId: 'previousContractSpendId',
    IsQuoteGenerationAllowed: 'isQuoteGenerationAllowed'
  };

  static SessionKey = {
    key: 'ngOnInit()',
    decryptKey: 'L@BR@D0RU|<',
    secretKey: 'L@BRADOR123'
  };
}

